import React, { useEffect, useState } from 'react';
import usePlacesAutocomplete, { getGeocode, getLatLng } from 'use-places-autocomplete';
import './locationInput.css';
import { useGoogleMaps } from '../../../../../context/GoogleMapsContext';

const LocationInput = ({ location, index, setState, updateLocation, removeLocation }) => {
  const isLoaded = useGoogleMaps();
  const [inputValue, setInputValue] = useState(location.address || '');

  const { ready, suggestions: { status, data }, setValue, clearSuggestions } = usePlacesAutocomplete({
    requestOptions: {
      componentRestrictions: { country: 'cl' },
    },
  });

  useEffect(() => {
    setInputValue(location.address || '');
  }, [location]);

  const handleSelect = async (address) => {
    setInputValue(address);
    clearSuggestions();

    try {
      const results = await getGeocode({ address });
      const { lat, lng } = await getLatLng(results[0]);

      setState((prevState) => {
        const existingLocation = prevState.locations[index];
        if (existingLocation && existingLocation.address === address) {
          return prevState;
        }

        const updatedLocation = {
          address: address,
          latitude: lat.toString(),
          longitude: lng.toString(),
        };

        return updateLocation(prevState, index, updatedLocation);
      });
    } catch (error) {
      console.error('Error fetching geocode data: ', error);
    }
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (newValue) {
      setValue(newValue);
    } else {
      clearSuggestions();
    }
  };

  // Handle when user finishes typing (onBlur)
  const handleInputBlur = () => {
    if (inputValue && inputValue.trim() !== '') {
      // Only geocode if we don't already have coordinates for this address
      const currentLocation = location;
      if (!currentLocation.latitude || !currentLocation.longitude || 
          currentLocation.latitude === '' || currentLocation.longitude === '') {
        geocodeAddress(inputValue);
      }
    }
  };

  // Debounced geocoding function
  const geocodeAddress = async (address) => {
    if (!address || address.trim() === '') return;
    
    try {
      const results = await getGeocode({ address });
      const { lat, lng } = await getLatLng(results[0]);
      
      
      setState((prevState) => {
        const updatedLocation = {
          address: address,
          latitude: lat.toString(),
          longitude: lng.toString(),
        };

        return updateLocation(prevState, index, updatedLocation);
      });
    } catch (error) {
      console.error('Error geocoding address:', error);
      // If geocoding fails, still update the address but with empty coordinates
      setState((prevState) => {
        const updatedLocation = {
          address: address,
          latitude: '',
          longitude: '',
        };

        return updateLocation(prevState, index, updatedLocation);
      });
    }
  };

  if (!isLoaded) {
    return <div className="location-input__error">Cargando...</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <h3>Ubicación {index + 1}</h3>
        <button
          type="button"
          className="company-profile-form__delete-button"
          onClick={() => removeLocation(index)}
        >
          ✕
        </button>
      </div>
      <div className="company-profile-form__label-input-container">
        <label>Dirección Local:</label>
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          disabled={!ready}
          className="location-input__input"
          placeholder="Buscar dirección..."
        />
        {status === 'OK' && (
          <div className="location-input__suggestions-container">
            {data.map((suggestion) => (
              <div
                key={suggestion.place_id}
                onClick={() => handleSelect(suggestion.description)}
                className="location-input__suggestion-item"
              >
                <p>{suggestion.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationInput;
